import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Search, ArrowRight } from "lucide-react";
import api from "@/lib/api";
import StatusPill from "@/components/marketplace/StatusPill";

const TABS = [["published,receiving_proposals", "Open"], ["provider_selected", "Hired"], ["canceled,expired,closed", "Closed"], ["", "All"]];

export default function AdminServiceRequestsPage() {
  const [tab, setTab] = useState(TABS[0][0]);
  const [q, setQ] = useState("");
  const [items, setItems] = useState(null);
  useEffect(() => {
    const t = setTimeout(() => api.get("/admin/service-requests/requests", { params: { status: tab || undefined, q: q || undefined } }).then((r) => setItems(r.data.items)), 250);
    return () => clearTimeout(t);
  }, [tab, q]);
  return (
    <div className="max-w-6xl" data-testid="admin-service-requests">
      <div className="text-xs font-bold tracking-[0.2em] uppercase text-[#165a71]">Request a Service</div>
      <h1 className="mt-1 font-display text-2xl md:text-3xl font-semibold text-[#071b22]">Service requests</h1>
      <p className="text-sm text-[#252A34]/65 mt-1">Open a request to send it to a specific pro or write an estimate for a pro.</p>
      <div className="mt-5 flex gap-2 flex-wrap">
        <div className="relative flex-1 min-w-[220px]"><Search className="h-4 w-4 absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" /><input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search by title" className="w-full rounded-full border border-slate-200 bg-white pl-9 pr-4 py-2 text-sm outline-none focus:border-[#165a71]" data-testid="asr-search" /></div>
        {TABS.map(([k, l]) => <button key={l} onClick={() => setTab(k)} className={`rounded-full px-4 py-2 text-sm ${tab === k ? "bg-[#071b22] text-white" : "bg-white border border-slate-200"}`} data-testid={`asr-tab-${l.toLowerCase()}`}>{l}</button>)}
      </div>
      <div className="mt-4 rounded-2xl border border-slate-200 bg-white divide-y divide-slate-100">
        {items === null ? <div className="p-6 text-sm text-[#252A34]/60">Loading…</div> : items.length === 0 ? <div className="p-8 text-center text-sm text-[#252A34]/60" data-testid="asr-empty">No requests.</div> : items.map((r) => (
          <Link key={r.id} to={`/admin/service-requests/${r.id}`} className="flex items-center gap-4 p-4 hover:bg-slate-50" data-testid={`asr-row-${r.id}`}>
            <div className="flex-1 min-w-0">
              <div className="flex items-center gap-3"><span className="font-medium text-[#071b22] truncate">{r.title}</span><StatusPill status={r.status} /></div>
              <div className="text-xs text-[#252A34]/60 mt-0.5">{r.customer?.display_name || r.customer?.email} · {r.address_snapshot?.city || r.kind} · {r.matched_count || 0} matched · {r.proposal_count || 0} estimate{r.proposal_count === 1 ? "" : "s"} · {r.submitted_at ? new Date(r.submitted_at).toLocaleDateString() : ""}</div>
            </div>
            <ArrowRight className="h-4 w-4 text-[#165a71]" />
          </Link>
        ))}
      </div>
    </div>
  );
}
